import { httpRequest } from '@igetcool/base-components';
const baseURLActivity = '/activity-course-server/';

export const courseMixin = {
  data() {
    return {
      tag: {
        chapterId: '', // 当前小节id
        close: false,
        show: false, // 小节tag
        popTime: null, // 小节tag弹出时间
        img: '', // 小节tag图片
        jumpUrl: '', // 小节tag跳转路由
      },
      popup: {
        chapterId: '', // 当前小节id
        close: false,
        show: false, // 小节弹窗
        popTime: null, // 小节弹窗弹出时间
        img: '', // 小节弹窗图片
        jumpUrl: '', // 小节弹窗跳转路由
      },
    };
  },
  methods: {
    // 获取课程小节标签
    getChapterTag(courseId, chapterId) {
      return httpRequest
        .get(baseURLActivity + 'api/course/resource/position/detail/tag', {
          courseId: courseId,
          chapterId: chapterId, // 小节id
          sourceType: 2, // 站外
        }, {
          headers: {
            'App-User-Pid': ''
          }
        });
    },
    // 获取课程小节弹窗
    getChapterPopup(courseId, chapterId) {
      return httpRequest
        .get(baseURLActivity + 'api/course/resource/position/chapter/popup', {
          courseId: courseId,
          chapterId: chapterId, // 小节id
        }, {
          headers: {
            'App-User-Pid': ''
          }
        });
    },
    // 监听媒体执行事件
    handleListenMedia(courseId, chapterId, media) {
      this.initTag();
      this.initPopup();

      this.getChapterTag(courseId, chapterId).then(tagRes => {
        if (tagRes.code === 10000 && tagRes.data) {
          this.tag.chapterId = chapterId;
          this.tag.popTime = tagRes.data.popTime;
          this.tag.img = tagRes.data.img;
          this.tag.jumpUrl = tagRes.data.jumpUrl;
        }
      });
      this.getChapterPopup(courseId, chapterId).then(popupRes => {
        if (popupRes.code === 10000 && popupRes.data) {
          this.popup.chapterId = chapterId;
          this.popup.popTime = popupRes.data.popTime;
          this.popup.img = popupRes.data.img;
          this.popup.jumpUrl = popupRes.data.jumpUrl;
        }
      });
      media.ontimeupdate = () => {
        if (!this.tag.close && this.tag.popTime && (media.currentTime >= this.tag.popTime)) {
          this.tag.show = true;
        }
        if (!this.popup.close && this.popup.popTime && (media.currentTime >= this.popup.popTime)) {
          this.popup.show = true;
        }
      };
    },
    // 初始化tag
    initTag() {
      this.tag.close = false;
      this.tag.show = false;
      this.tag.popTime = null;
      this.tag.img = '';
      this.tag.jumpUrl = '';
    },
    // 初始化tag
    initPopup() {
      this.popup.close = false;
      this.popup.show = false;
      this.popup.popTime = null;
      this.popup.img = '';
      this.popup.jumpUrl = '';
    },
    // 关闭tag
    tagClose() {
      this.tag.show = false;
      this.tag.close = true;
    },
    // 关闭popup
    popupClose() {
      this.popup.show = false;
      this.popup.close = true;
    },
    // tag 跳转
    handleHrefTag() {
      this.$coolHref(this.tag.jumpUrl);
    },
    // popup 跳转
    handleHrefPopup() {
      this.$coolHref(this.popup.jumpUrl);
    }
  }
};
